import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightUnits'
})
export class HighlightUnitsPipe implements PipeTransform {

  transform(value: string): { label: string, units: string } {
    if (!value) {
      return { label: '', units: '' };
    }
    const match = value.match(/(.* - )(\d+ unidades)/);
    return match ? { label: match[1], units: match[2] } : { label: value, units: '' };
  }

}
